export const BOX_SIZE = 65;
export const BOX_MARGIN = 3;
export const ANIMATION_DURATION = 50;
export const FLIP_ANIMATION_DURATION = 400;
export const FLIP_ANIMATION_DELAY = 220;